/* Zareen Jewels — customer screenshots: homepage rail + one shared full-size viewer.
   The viewer is built once and opened by any [data-zji-open] inside a [data-zji-group]
   (works for content added later too: cart updates, "show more" on collections). */
(() => {
  if (window.__zjInbox) return;
  window.__zjInbox = true;

  const ARROW_L = '<svg viewBox="0 0 20 12" width="16" height="10" aria-hidden="true"><path d="M20 6H2M7 1 2 6l5 5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';
  const ARROW_R = '<svg viewBox="0 0 20 12" width="16" height="10" aria-hidden="true"><path d="M0 6h18M13 1l5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>';

  /* ---------- homepage rail ---------- */
  function initRail(rail) {
    if (rail.dataset.zjiReady) return;
    rail.dataset.zjiReady = '1';
    const root = rail.closest('[data-zji-group]') || rail.parentElement;
    const bar = root.querySelector('[data-zji-bar]');
    const prev = root.querySelector('[data-zji-prev]');
    const next = root.querySelector('[data-zji-next]');
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      if (bar) {
        const w = rail.scrollWidth ? Math.max(0.12, rail.clientWidth / rail.scrollWidth) : 1;
        bar.style.setProperty('--w', (w * 100).toFixed(2) + '%');
        const track = bar.parentElement.clientWidth;
        const x = max > 0 ? (rail.scrollLeft / max) * (track - track * w) : 0;
        bar.style.setProperty('--x', x.toFixed(1) + 'px');
      }
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
    };
    const step = (dir) => {
      const card = rail.querySelector('.zji-shot');
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const w = card ? card.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
      const per = Math.max(1, Math.floor((rail.clientWidth + gap) / w));
      rail.scrollBy({ left: dir * w * per, behavior: 'smooth' });
    };
    prev && prev.addEventListener('click', () => step(-1));
    next && next.addEventListener('click', () => step(1));
    rail.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  const bootRails = (scope) => (scope || document).querySelectorAll('[data-zji-rail]').forEach(initRail);

  /* ---------- shared viewer ---------- */
  let box, stage, img, count, quote, tag, items = [], i = 0, lastFocus = null;

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'zji-box';
    box.hidden = true;
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Customer messages');
    box.innerHTML =
      '<span class="zji-box__backdrop" data-close aria-hidden="true"></span>' +
      '<figure class="zji-box__stage">' +
        '<img class="zji-box__img" alt="">' +
        '<figcaption class="zji-box__cap">' +
          '<span class="zji-box__count"></span>' +
          '<span class="zji-box__quote"></span>' +
          '<span class="zji-box__tag"></span>' +
        '</figcaption>' +
      '</figure>' +
      '<button type="button" class="zji-box__close" data-close aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<button type="button" class="zji-box__side zji-box__side--prev" data-go="-1" aria-label="Previous message">' + ARROW_L + '</button>' +
      '<button type="button" class="zji-box__side zji-box__side--next" data-go="1" aria-label="Next message">' + ARROW_R + '</button>';
    document.body.appendChild(box);
    stage = box.querySelector('.zji-box__stage');
    img = box.querySelector('.zji-box__img');
    count = box.querySelector('.zji-box__count');
    quote = box.querySelector('.zji-box__quote');
    tag = box.querySelector('.zji-box__tag');

    box.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', close));
    box.querySelectorAll('[data-go]').forEach((el) =>
      el.addEventListener('click', () => show(i + parseInt(el.dataset.go, 10)))
    );
    box.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(i + 1);
      else if (e.key === 'ArrowLeft') show(i - 1);
      else if (e.key === 'Tab') {
        const f = [...box.querySelectorAll('button')].filter((x) => x.offsetParent);
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    let x0 = null, y0 = 0, dx = 0;
    stage.addEventListener('touchstart', (e) => {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0;
      box.classList.add('is-dragging');
    }, { passive: true });
    stage.addEventListener('touchmove', (e) => {
      if (x0 === null) return;
      dx = e.touches[0].clientX - x0;
      if (Math.abs(dx) > Math.abs(e.touches[0].clientY - y0)) stage.style.setProperty('--drag', dx + 'px');
    }, { passive: true });
    stage.addEventListener('touchend', () => {
      box.classList.remove('is-dragging');
      stage.style.setProperty('--drag', '0px');
      if (Math.abs(dx) > 50) show(i + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    img.addEventListener('click', (e) => {
      if (items.length < 2) return;
      const r = img.getBoundingClientRect();
      show(i + (e.clientX - r.left < r.width / 3 ? -1 : 1));
    });
  }

  const pad = (n) => String(n).padStart(2, '0');
  function show(k) {
    if (!items.length) return;
    i = (k + items.length) % items.length;
    const it = items[i];
    img.src = it.src;
    img.alt = it.alt || 'Customer message';
    count.textContent = pad(i + 1) + ' / ' + pad(items.length);
    quote.textContent = it.quote ? '“' + it.quote + '”' : '';
    tag.textContent = it.tag || '';
    const n = items[(i + 1) % items.length];
    if (n && n.src) { const pre = new Image(); pre.src = n.src; }
    const multi = items.length > 1;
    box.querySelectorAll('[data-go]').forEach((b) => { b.hidden = !multi; });
  }
  function open(list, k) {
    build();
    items = list;
    lastFocus = document.activeElement;
    show(k);
    box.hidden = false;
    document.documentElement.classList.add('zji-lock');
    requestAnimationFrame(() => box.classList.add('is-open'));
    box.querySelector('.zji-box__close').focus({ preventScroll: true });
  }
  function close() {
    if (!box || box.hidden) return;
    box.classList.remove('is-open');
    document.documentElement.classList.remove('zji-lock');
    setTimeout(() => { box.hidden = true; img.removeAttribute('src'); }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  const cache = new WeakMap();
  function itemsFor(group) {
    if (cache.has(group)) return cache.get(group);
    let list = [];
    const data = group.querySelector('script[data-zji-items]');
    try { list = JSON.parse(data ? data.textContent : '[]'); } catch (e) { list = []; }
    cache.set(group, list);
    return list;
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-zji-open]');
    if (!btn) return;
    const group = btn.closest('[data-zji-group]');
    if (!group) return;
    const list = itemsFor(group);
    if (!list.length) return;
    e.preventDefault();
    open(list, parseInt(btn.dataset.zjiOpen, 10) || 0);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bootRails());
  else bootRails();
  document.addEventListener('shopify:section:load', (e) => bootRails(e.target));
})();
